module.exports = __webpack_public_path__ + "img/Python.e99e030c.png";